import { InfoLabel, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "@fluentui/react-components";

export default function HUDMainPanel_Stats() {
    return (
        <div>
            <h4>My Stats</h4>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Stat</TableHeaderCell>
                        <TableHeaderCell>Value</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Health" info={"Your current and maximum health points."} />
                        </TableCell>
                        <TableCell>100 / 100</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Effects" info={"Positive and negative effects applied to your character which may affect other stats."} />
                        </TableCell>
                        <TableCell>
                            None
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
}